import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import InsightsServices from "../../services/Insights.services";

function useKeywordSuggestion() {
    const dispatch = useDispatch()

    const [kwsuggestionList, setKwsuggestionList] = useState([])
    const [loadingKWSuggestion, setLoadingKWSuggestion] = useState(false)
    const [selectedKWSuggestion, setSelectedKWSuggestion] = useState([])
    const { lowscore } = useSelector((state) => state.minified)

    const getSuggestionKeywords = (givenKeyword, removeGivenKeyword) => {
        setLoadingKWSuggestion(true)
        InsightsServices.getKeywordSuggestion(givenKeyword).then((resp) => {
            if (givenKeyword) {
                const temp = givenKeyword.map((txt) => txt.toLocaleLowerCase())
                setKwsuggestionList(removeGivenKeyword ? (resp.data || []).filter((txt) => !temp.includes(txt.toLocaleLowerCase())) : resp.data)
            } else {
                setKwsuggestionList(resp.data)
            }
            setLoadingKWSuggestion(false)
        })
    };

    useEffect(() => {
        if (lowscore) {
            getSuggestionKeywords();
        }
    }, [lowscore])

    return {
        kwsuggestionList,
        selectedKWSuggestion,
        setSelectedKWSuggestion,
        loadingKWSuggestion,
        getSuggestionKeywords
    };
}

export default useKeywordSuggestion;
